import * as ActionType from '../constants/constant_action_types';
import messages from '../components/common/translation_common';

const defaultState = {
  isModalActive: false,
  header: messages.title_prompt.defaultMessage,
  body: null,
  confirmOnly: true,
};

export function CommonPromptModalReducer(state = defaultState, action) {
  switch (action.type) {
    case ActionType.COMMON_PROMPT_MODAL_SHOW:
      return {
        ...defaultState,
        ...action.payload,
        isModalActive: true,
      };
    case ActionType.COMMON_PROMPT_MODAL_HIDE:
      return defaultState;
    default:
      return state;
  }
}
